(() => {
    class Video extends App.Component {
        constructor(container) {
            super(container);
            this.subIndex        = container.dataset.subIndex;
            this.index           = this.subIndex ? container.closest('section').dataset.index : container.dataset.index;
            this.wrapper         = container.querySelector('.video-container')
            this.consent         = container.querySelector('.video-consent');
            this.iframe          = container.querySelector('iframe');
            this.properties      = this.subIndex ? container.parentElement.querySelector('.js-subsection-control-panel .action.properties') : null;
            this.form            = container.querySelector('form[name=\'videosection\']')
            this.subFormSelector = `.cms-section-information[data-index='${this.index}'] form[name='videosection']`;
            this.cookieName      = 'mmYoutubeConsent';
            this.path            = '/';

            if (App.Variable('editMode')) {
                this.cms();
            } else {
                this.run();
            }

            /* GLOBALIZE */
            App.Components.wait(this.container, 'Instance', I => App.Components.Video = I);
        }

        getVideoId(url) {
            let videoId = '';
            let pattern = '^(?:https?:)?//[^/]*(?:youtube(?:-nocookie)?\.com|youtu\.be).*[=/]([-\\w]{11})(?:\\?|=|&|$)';
            const matches = url.match(pattern);

            if (matches) {
                videoId = matches[1];
            }

            return videoId;
        }

        cms() {
            if (this.properties) {
                const form = document.querySelector(this.subFormSelector);
                this.properties.addEventListener('click', () => {
                    setTimeout(() => {
                        this.update(document.querySelector(this.subFormSelector));
                    }, 100);
                });

                if (form) {
                    this.update(form);
                }
            } else {
                this.update();
            }
        }

        run() {
            if (($.cookie('cookies_consent_performance') === 'true' && $.cookie('cookies_consent_targeting') === 'true') || $.cookie('mmYoutubeConsent') === 'true') {
                this.iframe.src = this.iframe.dataset.src;
                this.iframe.dataset.src = '';
                this.consent.remove();
                this.wrapper.classList.remove('preview');

            }
        }

        update(form = this.form) {
            if (form) {
                const formData      = new FormData(form);
                const url           = formData.get('url');
                const fluid         = parseInt(formData.get('fluid'));
                const width         = parseInt(formData.get('width'));
                const height        = parseInt(formData.get('height'));
                const autoplay      = parseInt(formData.get('autoplay'));
                const loop          = parseInt(formData.get('loop'));
                const controls      = parseInt(formData.get('controls'));
                const fullscreen    = parseInt(formData.get('fullscreen'));

                if (url) {
                    const id = this.getVideoId(url);
                    let newUrl = `https://www.youtube-nocookie.com/embed/${id}?modestbranding=1&rel=0`;

                    if (autoplay) {
                        newUrl += `&autoplay=${autoplay}&mute=1`;
                    }

                    if (loop) {
                        newUrl += `&loop=1&playlist=${id}`;
                    }

                    newUrl += `&controls=${controls}`;
                    newUrl += `&fs=${fullscreen}`;

                    this.iframe.src = newUrl;
                    this.iframe.width = width;
                    this.iframe.height = height;
                    this.wrapper.style.width = `${width}px`;
                    this.wrapper.style.height = `${height}px`;

                    if (fluid) {
                        this.iframe.parentElement.classList.add('fluid');
                    } else {
                        this.iframe.parentElement.classList.remove('fluid');
                    }
                }
            }
        }
    }

    App.Components.register('section.video-section', Video);
    App.Components.register('.cms-subsection[data-type=\'video\']', Video);
})();
